<template>

  <v-card class="pa-6 ma-md-10 bg-white-show-through">

    <!-- title -->
    <v-card-title class="card-title">
      <v-icon large class="indigo--text mr-3">{{$t('sadmin.tenant_create.icon')}}</v-icon>
      {{ $t('sadmin.tenant_create.title')}}
    </v-card-title>

    <v-divider class="my-4"></v-divider>

    <v-card-text>

      <v-row>

        <AppAlert :alert="alert"/>

        <v-col cols="12" md="8">
          <v-form ref="form" :loading="isLoading">

            <!-- name -->
            <v-text-field
                    v-model="tenant.name"
                    :counter="10"
                    :rules="[v => !!v || 'Name is required']"
                    :label="$t('sadmin.tenant_create.name_label')"
                    required>
            </v-text-field>

            <!-- initial admin username -->
            <v-text-field
                    v-model="tenant.initialAdminUserName"
                    :counter="10"
                    :label="$t('sadmin.tenant_create.initial_admin_username_label')"
                    required>
            </v-text-field>

            <!-- create test data -->
            <v-switch
                    v-model="tenant.createTestData"
                    :label="$t('sadmin.tenant_create.create_test_data_label')"
                    inset>
            </v-switch>

            <!-- type -->
            <v-select
                    v-model="tenant.type"
                    :items="TenantType.VALUES"
                    :rules="[v => !!v || 'Type is required']"
                    :label="$t('sadmin.tenant_create.type_label')"
                    color="indigo"
                    required
                    inset>
            </v-select>

            <!-- status -->
            <v-select
                    v-model="tenant.status"
                    :items="TenantStatus.VALUES"
                    :rules="[v => !!v || 'Status is required']"
                    :label="$t('sadmin.tenant_create.status_label')"
                    required>
            </v-select>

            <!-- create button -->
            <v-btn color="success" class="mt-4" @click="createTenant()" :loading="isLoading">
              <v-icon class="mr-3">mdi-creation</v-icon>
              {{$t('sadmin.tenant_create.create_btn_label')}}
            </v-btn>

          </v-form>

        </v-col>
      </v-row>

    </v-card-text>

  </v-card>

</template>

<script>
  import { TenantStatus, TenantType, Tenant } from '@/shared/models';
  import { TenantsApi } from '@/shared/services/api/tenants'

  export default {
    name: 'TenantCreate',
    data () {
      return {
        TenantStatus,
        TenantType,
        tenant: new Tenant({
          createTestData: true,
          type: TenantType.LOCATION,
          status: TenantStatus.ACTIF
        }),
        isLoading: false,
        alert: null
      };
    },
    methods: {
      createTenant () {
        this.isLoading = true;
        this.alert = null;
        TenantsApi.createTenant(this.tenant)
          .then(tenant => {
            console.log("Created successfuly", tenant);
            this.tenant = tenant;
            this.alert = {
              type: 'success',
              message: 'Tenant Created successfuly'
            };
          })
          .catch(error => this.alert = error)
          .finally(() => this.isLoading = false);
      }
    }
  };
</script>

